<template>
  <div class="v2-stripes">
    <!-- see more https://decasoft.net/  -->
    <div class="v2-stripes__wrap">
      <div class="v2-stripes__box">
        <div class="v2-stripes__stripe"></div>
        <div class="v2-stripes__stripe"></div>
        <div class="v2-stripes__stripe"></div>
        <div class="v2-stripes__stripe"></div>
        <div class="v2-stripes__stripe"></div>
        <div class="v2-stripes__stripe"></div>
        <div class="v2-stripes__stripe"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "V2Stripes",
};
</script>
